import {ArrowRightOutlined} from "@ant-design/icons";
import _ from "lodash";
import React from "react";
import SbomComponent from "../../domain/SbomComponent";
import FindingStatistics from "./FindingStatistics";
import * as styles from "./FindingStatisticsImpact.module.css";

interface Props {
    findingStatistics: any;
    component: SbomComponent;
    compact?: boolean;
}

export default function FindingStatisticsImpact(props: Props) {
    if (_.isEqual(props.findingStatistics, props.component.analysedFindingStatistics)) {
        return <FindingStatistics findingStatistics={props.findingStatistics} compact={props.compact}/>;
    }

    return <>
        <FindingStatistics findingStatistics={props.findingStatistics} compact={props.compact}/>
        <ArrowRightOutlined className={styles['analysis-arrow']} title={"Impact of analysis"}/>
        <FindingStatistics findingStatistics={props.component.analysedFindingStatistics} compact={props.compact}/>
    </>;
}
